<template>
  <div>
    <div class="vx-row" id="formulation_qa_table">
      <div class="vx-col w-full">
        <vx-card no-shadow>

          <ValidationObserver ref="form" v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(onClickSave)">
              <span v-if="!is_spec_available" class="text-danger text-lg">
                Note: There are missing data points for a prod spec to be sent & generate.
              </span>

              <div class="flex flex-wrap items-center justify-end mt-2"  v-if="$can('download-provisional-product-specification')">
                <vs-button :disabled="!is_spec_available" @click.stop="onClickViewProductSpecPdf()"
                           class="ml-auto mr-2 mt-2" color="primary" size="small" type="border">Product spec PDF
                </vs-button>
                <vs-button button="submit" v-if="$canAll(formulationProductSpecificationPermissions)"
                           class="mt-2" color="primary" size="small" type="filled">Save Changes
                </vs-button>
              </div>

              <div class="vx-row mb-3">
                <!-- <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider vid="label_declaration" name="label_declaration" rules="required" v-slot="{ errors }">
                    <small class="label">Label Declaration/EU Status</small>
                    <v-select :clearable="false" name="label_declaration" placeholder=""
                              v-model="form.label_declaration"
                              v-on:input="onSelectLabelDeclaration"
                              :disabled="!$canAll(formulationProductSpecificationPermissions)"
                              :options="label_declaration_options" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    />
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div> -->
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider vid="classification" name="classification" rules="required" v-slot="{ errors }">
                    <small class="label">Classification <span class="text-danger text-lg">*</span></small>
                    <v-select :clearable="false" name="classification" placeholder=""
                              :disabled="!$canAll(formulationProductSpecificationPermissions)"
                               v-model="form.classification" :options="['Natural', 'Artificial']" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    />
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider vid="form" name="form" rules="required" v-slot="{ errors }">
                    <small class="label">Form <span class="text-danger text-lg">*</span></small>
                    <vs-input type="text" v-model="form.form" name="form" class="w-full" :danger="!!errors[0]"
                              :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                              :disabled="!$canAll(formulationProductSpecificationPermissions)"/>
                  </ValidationProvider>
                </div>
              </div>

              <div class="vx-row mb-3">
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider vid="country_of_origin" name="country_of_origin" rules="required" v-slot="{ errors }">
                    <small class="label">Country of Origin <span class="text-danger text-lg">*</span></small>
                    <v-select :clearable="false" name="country_of_origin" placeholder="" label="name" :reduce="option => option.name"
                              :disabled="!$canAll(formulationProductSpecificationPermissions)"
                              v-model="form.country_of_origin" :options="countries" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    />
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider vid="country_of_manufacture" name="country_of_manufacture" rules="required" v-slot="{ errors }">
                    <small class="label">Country of Manufacturing <span class="text-danger text-lg">*</span></small>
                    <v-select :clearable="false" name="country_of_manufacture" placeholder="" label="name" :reduce="option => option.name"
                              :disabled="!$canAll(formulationProductSpecificationPermissions)"
                              v-model="form.country_of_manufacture" :options="countries" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    />
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-row mb-3">
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider vid="shelf_life" name="shelf_life" rules="required" v-slot="{ errors }">
                    <small class="label">Best before date (months) <span class="text-danger text-lg">*</span></small>
                    <vs-input type="text" v-model="form.shelf_life" name="shelf_life" class="w-full" :danger="!!errors[0]"
                              :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                              :disabled="!$canAll(formulationProductSpecificationPermissions)"/>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider vid="restricted_substances_BAPs" name="restricted_substances_BAPs" rules="required" v-slot="{ errors }">
                    <small class="label">Restricted Substances BAPs <span class="text-danger text-lg">*</span></small>
                    <vs-input type="text" v-model="form.restricted_substances_BAPs" name="restricted_substances_BAPs" class="w-full"
                              :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                              val-icon-pack="feather" :disabled="!$canAll(formulationProductSpecificationPermissions)"/>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-row mb-3" v-if="formulation.formulation_type === 'liquid'">
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider vid="sg" name="sg" rules="required" v-slot="{ errors }">
                    <small class="label">SG <span class="text-danger text-lg">*</span></small>
                    <vs-input type="text" v-model="form.sg" name="sg" class="w-full" :danger="!!errors[0]"
                              :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                              :disabled="!$canAll(formulationProductSpecificationPermissions)"/>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider vid="ri" name="srig" rules="required" v-slot="{ errors }">
                    <small class="label">RI <span class="text-danger text-lg">*</span></small>
                    <vs-input type="text" v-model="form.ri" name="ri" class="w-full" :danger="!!errors[0]"
                              :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                              :disabled="!$canAll(formulationProductSpecificationPermissions)"/>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-row mb-3">
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider vid="appearance" name="appearance" rules="required" v-slot="{ errors }">
                    <small class="label">Appearance <span class="text-danger text-lg">*</span></small>
                    <vs-input type="text" v-model="form.appearance" name="appearance" class="w-full" :danger="!!errors[0]"
                              :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                              :disabled="!$canAll(formulationProductSpecificationPermissions)"/>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider vid="storage_condition" name="storage_condition" rules="required" v-slot="{ errors }">
                    <small class="label">Storage Condition <span class="text-danger text-lg">*</span></small>
                    <vs-input type="text" v-model="form.storage_condition" name="storage_condition" class="w-full" :danger="!!errors[0]"
                              :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                              :disabled="!$canAll(formulationProductSpecificationPermissions)"/>
                  </ValidationProvider>

                </div>
              </div>
              
              <div class="vx-row mb-3">
                <vx-card subtitle="" cardBorder>
                  <div class="vx-row">
                    <div class="vx-col md:w-full w-full md:mb-0">
                      <ValidationProvider vid="composition" name="composition" rules="required" v-slot="{ errors }">
                        <small class="label">Composition <span class="text-danger text-lg">*</span></small>
                        <vs-textarea  v-model="form.composition" name="" id=""></vs-textarea>
                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="vx-row">
                    <div class="vx-col">
                      <small class="mb-2">*Please select options from below section to add</small>
                    </div>
                  </div>
                  <div class="vx-row mt-4">
                    <div class="vx-col">
                      <vs-button size="small" class="mr-2 mb-2 hover:bg-danger rounded" 
                        v-for="(com, com_index) in composition_options" :key="com_index" @click.stop="onClickComposition(com.name)">
                        {{ com.name }}
                      </vs-button>
                    </div>
                  </div>
                </vx-card>
              </div>

              <div class="vx-row mt-8">
                <div class="vx-col w-full">
                  <vs-table stripe :hoverFlat="true" :data="form.allergen_data">

                    <template slot="thead">
                      <vs-th width="40%">Recipe free from</vs-th>
                      <vs-th width="10%">Yes/No</vs-th>
                      <vs-th width="50%">Comment</vs-th>
                    </template>

                    <template slot-scope="{data}">
                      <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                        <vs-td :data="data[indextr].label">
                          {{ data[indextr].label }}
                        </vs-td>

                        <vs-td :data="data[indextr].is_required">
                          <vs-switch v-model="data[indextr].is_required" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16"
                                     :disabled="!$canAll(formulationProductSpecificationPermissions)">
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                        </vs-td>

                        <vs-td :data="data[indextr].comment">
                          <vs-input :disabled="!$canAll(formulationProductSpecificationPermissions)" type="text" v-model="data[indextr].comment" name="comment" class="w-full"/>
                        </vs-td>
                      </vs-tr>
                    </template>

                  </vs-table>
                </div>
              </div>

            </form>
          </ValidationObserver>

        </vx-card>
      </div>
    </div>
    <product-specification-document-pop-up ref="productSpecificationDocumentPopUp"/>
    <vs-prompt
      @cancel="onClosePrompt"
      @accept="onInputLabelDeclarationName"
      @close="onClosePrompt"
      :title="form.label_declaration"
      :accept-text="'Save Name'"
      :color="'primary'"
      :active.sync="activePrompt">
      <div class="con-exemple-prompt">
        <span>Input name</span>
        <vs-input v-model="label_declaration_name" class="mt-3 w-full" />
      </div>
    </vs-prompt>
    <vs-prompt
      @cancel="onClosePromptComposition"
      @accept="onInputCompositionBand"
      @close="onClosePromptComposition"
      :title="composition_name"
      :accept-text="'Save'"
      :color="'primary'"
      :active.sync="activePromptComposition">
      <div class="con-exemple-prompt">
        <span>Input Banding (%)</span>
        <vs-input v-model="composition_banding" @keyup.enter="onInputCompositionBand" class="mt-3 w-full" />
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import {RepositoryFactory} from '@/repository/RepositoryFactory'
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

const FormulationsRepository = RepositoryFactory.get('formulations')
import ProductSpecificationDocumentPopUp
  from "@/components/popups/formulations/product-spec/ProductSpecificationDocumentPopUp";
import vSelect from "vue-select";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "FormulationProvisionalProductSpecificationTab",
  data() {
    return {
      formulationId: '',
      activePrompt: false,
      activePromptComposition: false,
      label_declaration_name: '',
      composition_banding: '',
      composition_name: '',
      label_declaration_options: [
        'Natural flavouring',
        'Flavouring',
        'Natural {name} flavouring',
        'Natural {name} flavourings with other natural flavourings',
        'Organic {name} flavouring',
        'Natural colour',
        'Artificial colour',
      ],
      composition_options: [
        // "Natural Flavouring Substances",
        // "Flavouring Substances",
        // "Flavouring Preparations",
        // "Carrier: Propylene Glycol E1520 (%)",
        // "Carrier: Triacetin E1518 (%)",
        // "Carrier: Ethanol (%)",
        // "Carrier: MCT Oil (%)",
        // "Carrier: High Oleic Sunflower Oil (%)",
        // "Carrier: Maltodextrin",
        // "Carrier: Dried Glucose Syrup",
        // "Carrier: Rice Flour",
        // "Carrier: Gum Acacia",
        // "Water (%)",
        // "Anticaking Agent E551 (%)",
        // "Sucralose",
        // "Citric Acid E330",
        // "Malic Acid E296",
        // "Tartaric Acid E334",
        // "Xanthan Gum E415",
        // "Sodium Benzoate E211",
        // "Potassium Sorbate E202",
        // "Natural Colouring: Shade Vivid Red",
        // "Natural Colouring: Shade Fiesta Pink",
        // "Natural Colouring: Shade Lemon Yellow",
      ],
      allergens: [
        {
          label: 'Cereals containing gluten and products thereof',
          name: "cereal",
          is_required: true,
          comment: ""
        },
        {
          label: 'Crustaceans and products thereof',
          name: "crustaceans",
          is_required: true,
          comment: ""
        },
        {
          label: 'Eggs and products thereof',
          name: "eggs",
          is_required: true,
          comment: ""
        },
        {
          label: 'Fish and products thereof',
          name: "fish",
          is_required: true,
          comment: ""
        },
        {
          label: 'Peanuts and products thereof',
          name: "peanuts",
          is_required: true,
          comment: ""
        },
        {
          label: 'Soya beans and products thereof',
          name: "soya_bean",
          is_required: true,
          comment: ""
        },
        {
          label: 'Milk and dairy products (including lactose)',
          name: "milk",
          is_required: true,
          comment: ""
        },
        {
          label: 'Nuts and nut products',
          name: "nuts",
          is_required: true,
          comment: ""
        },
        {
          label: 'Celery and products thereof',
          name: "celery",
          is_required: true,
          comment: ""
        },
        {
          label: 'Mustard and products thereof',
          name: "mustard",
          is_required: true,
          comment: ""
        },
        {
          label: 'Sesame seeds and products thereof',
          name: "sesame",
          is_required: true,
          comment: ""
        },
        {
          label: 'Sulphur dioxide and sulphites at concentrations of more than 10 mg/kg or 10 ml/litre',
          name: "sulphur_sulphite",
          is_required: true,
          comment: ""
        },
        {
          label: 'Molluscs and products thereof',
          name: "molluscs",
          is_required: true,
          comment: ""
        },
        {
          label: 'Lupins and products thereof',
          name: "lupins",
          is_required: true,
          comment: ""
        }
      ],
      form: {
        classification: '',
        label_declaration: '',
        composition: '',
        country_of_origin: '',
        country_of_manufacture: '',
        form: '',
        restricted_substances_BAPs: '',
        shelf_life: '',
        storage_condition: 'Store in cool conditions away from light and strong odours',
        allergen_data: [
          {
            label: 'Cereals containing gluten and products thereof',
            name: "cereal",
            is_required: true,
            comment: ""
          },
          {
            label: 'Crustaceans and products thereof',
            name: "crustaceans",
            is_required: true,
            comment: ""
          },
          {
            label: 'Eggs and products thereof',
            name: "eggs",
            is_required: true,
            comment: ""
          },
          {
            label: 'Fish and products thereof',
            name: "fish",
            is_required: true,
            comment: ""
          },
          {
            label: 'Peanuts and products thereof',
            name: "peanuts",
            is_required: true,
            comment: ""
          },
          {
            label: 'Soya beans and products thereof',
            name: "soya_bean",
            is_required: true,
            comment: ""
          },
          {
            label: 'Milk and dairy products (including lactose)',
            name: "milk",
            is_required: true,
            comment: ""
          },
          {
            label: 'Nuts and nut products',
            name: "nuts",
            is_required: true,
            comment: ""
          },
          {
            label: 'Celery and products thereof',
            name: "celery",
            is_required: true,
            comment: ""
          },
          {
            label: 'Mustard and products thereof',
            name: "mustard",
            is_required: true,
            comment: ""
          },
          {
            label: 'Sesame seeds and products thereof',
            name: "sesame",
            is_required: true,
            comment: ""
          },
          {
            label: 'Sulphur dioxide and sulphites at concentrations of more than 10 mg/kg or 10 ml/litre',
            name: "sulphur_sulphite",
            is_required: true,
            comment: ""
          },
          {
            label: 'Molluscs and products thereof',
            name: "molluscs",
            is_required: true,
            comment: ""
          },
          {
            label: 'Lupins and products thereof',
            name: "lupins",
            is_required: true,
            comment: ""
          }
        ]
      },
      is_spec_available: false,
    }
  },
  props: {
    formulation_data: {
      type: Object,
      default: {},
    },
    formulationPermissions: {
      type: Array,
      default: [],
    }
  },
  methods: {
    async onClickSave() {
      try {
        const payload = {}
        Object.assign(payload, this.form)
        payload.label_declaration = "."
        payload.allergen_data = payload.allergen_data.map((n) => ({ name: n.label, is_required: n.is_required, comment: n.comment }))
        await FormulationsRepository.updateProvisionalProductSpecification(this.formulationId, payload)
        await this.$emit('refreshGeneral')
        await this.checkProductSpec()
        this.showSuccessMessage('ProvisionalProduct specification saved successfully')
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async onClickViewProductSpecPdf() {
      await this.$refs.productSpecificationDocumentPopUp.openPopup(this.formulationId, this.formulation.formulation_code, this.formulation.name, 'provisional-product-specification-pdf')
    },
    onSelectLabelDeclaration() {
      if(this.form.label_declaration.includes(' {name} ')) {
        this.activePrompt = true
      }
    },
    onClickComposition(comp) {
      if(comp.includes('%')) {
        this.composition_name = comp
        this.activePromptComposition = true
      } else {
        this.form.composition = `${this.form.composition ? this.form.composition : ''}, ${comp}`
      }
    },
    onInputLabelDeclarationName() {
      this.activePrompt = false
      this.form.label_declaration = this.form.label_declaration.replace('{name}', this.label_declaration_name)
      this.label_declaration_name = ''
    },
    onInputCompositionBand() {
      this.activePromptComposition = false
      this.form.composition= `${this.form.composition ? this.form.composition : ''}, ${this.composition_name.replace('%', `(${this.composition_banding})`)}`
      this.composition_banding = ''
      this.composition_name = ''
    },
    onClosePrompt() {
      this.form.label_declaration = null
      this.label_declaration_name = ''
      this.activePrompt = false
    },
    onClosePromptComposition() {
      this.composition_banding = ''
      this.composition_name = ''
      this.activePromptComposition = false
    },
    async fetchCompositionList() {
      try {
        const { data } = (await FormulationsRepository.getCompositionList(1, '', 50, '')).data
        this.composition_options = data
      } catch (error) {
        
      }
    },
    async checkProductSpec() {
      const { data } = (await FormulationsRepository.checkSpectOfProduct({ formulations: [ this.formulation_data.formulation_code ] })).data
      this.is_spec_available = data[this.formulation_data.formulation_code]
    },
    ...mapActions(['fetchCountries']),
  },
  async mounted() {
    this.formulationId = this.$route.params.id  
    if(this.formulation.provisional_product_specification) {
      this.form = this.formulation.provisional_product_specification
      this.form.country_of_origin = this.formulation.product_specification.country_of_origin || 'Great Britain'
      this.form.country_of_manufacture = this.formulation.product_specification.country_of_manufacture || 'Great Britain'
      this.form.label_declaration = this.formulation.product_specification.label_declaration || this.formulation.legal_name
      this.form.storage_condition = this.formulation.provisional_product_specification.storage_condition || 'Store in cool conditions away from light and strong odours'
    }
    if(this.formulation.provisional_product_specification && this.formulation.provisional_product_specification.allergens.length === 0) {
      this.form.allergen_data =   [
        {
          label: 'Cereals containing gluten and products thereof',
          name: "cereal",
          is_required: true,
          comment: ""
        },
        {
          label: 'Crustaceans and products thereof',
          name: "crustaceans",
          is_required: true,
          comment: ""
        },
        {
          label: 'Eggs and products thereof',
          name: "eggs",
          is_required: true,
          comment: ""
        },
        {
          label: 'Fish and products thereof',
          name: "fish",
          is_required: true,
          comment: ""
        },
        {
          label: 'Peanuts and products thereof',
          name: "peanuts",
          is_required: true,
          comment: ""
        },
        {
          label: 'Soya beans and products thereof',
          name: "soya_bean",
          is_required: true,
          comment: ""
        },
        {
          label: 'Milk and dairy products (including lactose)',
          name: "milk",
          is_required: true,
          comment: ""
        },
        {
          label: 'Nuts and nut products',
          name: "nuts",
          is_required: true,
          comment: ""
        },
        {
          label: 'Celery and products thereof',
          name: "celery",
          is_required: true,
          comment: ""
        },
        {
          label: 'Mustard and products thereof',
          name: "mustard",
          is_required: true,
          comment: ""
        },
        {
          label: 'Sesame seeds and products thereof',
          name: "sesame",
          is_required: true,
          comment: ""
        },
        {
          label: 'Sulphur dioxide and sulphites at concentrations of more than 10 mg/kg or 10 ml/litre',
          name: "sulphur_sulphite",
          is_required: true,
          comment: ""
        },
        {
          label: 'Molluscs and products thereof',
          name: "molluscs",
          is_required: true,
          comment: ""
        },
        {
          label: 'Lupins and products thereof',
          name: "lupins",
          is_required: true,
          comment: ""
        }
      ]
    }
    if(this.formulation.provisional_product_specification && this.formulation.provisional_product_specification.allergens.length !== 0) {
      this.form.allergen_data = this.formulation.provisional_product_specification.allergens.map((n) => {
        let find = this.allergens.find((m) => m.label === n.name)
        return { comment: n.comment, name: n.name, is_required: n.is_required, label: find.label }
      })
    }
    await this.fetchCountries()
    await this.fetchCompositionList()
    await this.checkProductSpec()
  },
  computed: {
    ...mapGetters(["countries"]),
    formulation: function () {
      return this.formulation_data
    },
    formulationProductSpecificationPermissions: function () {
      return this.formulationPermissions.concat([ 'qc-elements-edit', 'edit-provisional-product-specification' ])
    }
  },
  components: {
    'v-select': vSelect,
    ProductSpecificationDocumentPopUp
  },
  mixins: [SuccessMessage, ErrorMessages]
}
</script>

<style scoped>

.__table-heading-small {
  /*font-size: x-small;*/
  /*font-weight: normal;*/
}

</style>
